
<!-- start documents -->
<div class="w-100 d-flex justify-content-between py-6">
  <hr class="w-100">
  <h1 class="w-25 text-center" translate>search.documents</h1>
  <hr class="w-100">
</div>

<!-- documents list card -->
<div  class="card w-50 mx-auto mb-5 content flex-row-fluid pt-4">
  <!-- <div class="card-header align-items-center justify-content-start card-rounded py-2">
    <h3 class="card-title align-items-center">
        <span class="card-label fw-bold text-dark-emphasis"></span>
    </h3>
  </div> -->
  <div class="card-body scroll-y max-h-350px" >
    <!-- single item -->
    <ng-container *ngFor="let document of data$ | async as documents">
    <div  class="separator separator-dashed my-3" ></div>
    <div  class="pe-6 me-n6">
      <div class="d-flex align-items-sm-center">
        <div class="d-flex flex-row-fluid flex-wrap align-items-center">
          <div class="flex-grow-1 me-auto">
            <a href="{{document?.url}}" target="_blank" class="text-gray-500 fw-bolder text-hover-primary fs-6">
              {{document.title}}
            </a>
          </div>
        </div>                          
      </div>
    </div>
  </ng-container>
    <!-- end single item -->
  </div>
</div>
<!-- end documents list card -->
<!-- end documents -->
